import { useEffect, useState } from 'react';
import css from './AddInvoice.module.css'; // Reusing same CSS module

import * as invoiceServices from '../../../../services/invoiceService.js';
import * as contractServices from '../../../../services/contractService.js';
import * as customerServices from '../../../../services/customerServices.js';
import toShort from '../../../../services/utils/dateParser.js';

function AddInvoice({ onAdd, onClose, func = 'Add', data }) {
    const [options, setOptions] = useState();
    const [allContracts, setAllContracts] = useState([]);

    const template = {
        invoiceId: data?.invoiceId || 0,
        invoiceNo: data?.invoiceNo || '',
        invoiceDate: toShort(data?.invoiceDate, 1) || toShort(new Date(), 1),
        customerId: data?.customerId || 1,
        contractId: data?.contractId || null,
        invoiceTrainingAmount: data?.invoiceTrainingAmount || 0,
        invoiceAccessAmount: data?.invoiceAccessAmount || 0,
        invoiceOtherAmount: data?.invoiceOtherAmount || 0,
        invoiceTotalAmount: data?.invoiceTotalAmount || 0,
        invoiceNote: data?.invoiceNote || '',
        isInvoicePaid: data?.isInvoicePaid ?? 0,
    };

    const [newData, setNewData] = useState(template);
    // const [filteredContracts, setFilteredContracts] = useState([options?.contracts || []]);
    const [filteredCustomers, setFilteredCustomers] = useState([]);

    useEffect(() => {
        Promise.all([contractServices.getAll(1), customerServices.getAll(1)])
            .then(([contracts, customers]) => {
                setOptions({
                    customers: customers.data,
                });
                setFilteredCustomers(customers.data);
                setAllContracts(contracts.data); // Store all contracts separately
            })
            .catch((err) => console.error(err));
    }, []);

    const onChange = (e) => {
        const { id, value, type } = e.currentTarget;
        setNewData((prev) => ({
            ...prev,
            [id]: type === 'number' ? parseFloat(value) : value,
        }));

        if (id === 'customerId') {
            setNewData((prev) => ({
                ...prev,
                customerId: value,
                contractId: '', // Reset contract when customer changes
            }));
        } else {
            setNewData((prev) => ({
                ...prev,
                [id]: type === 'number' ? parseFloat(value) : value,
            }));
        }
    };

    const onTogglePaid = () => {
        setNewData((prev) => ({ ...prev, isInvoicePaid: prev.isInvoicePaid ? 0 : 1 }));
    };

    const filterCustomers = (e) => {
        const value = e.currentTarget.value.toLowerCase();
        const filteredArr = options.customers.filter((x) => x.customerName.toLowerCase().includes(value));
        setFilteredCustomers(filteredArr);
        if (filteredArr.length) {
            setNewData((prev) => ({ ...prev, customerId: filteredArr[0].customerId }));
        }
    };

    return (
        <form>
            <h3>{func === 'Add' ? 'Add New Invoice' : 'Edit Invoice'}</h3>
            <div className={css.formArea}>
                <div className={css.inputs}>
                    <label htmlFor="invoiceNo">
                        Invoice No
                        <input type="text" id="invoiceNo" onChange={onChange} value={newData.invoiceNo} />
                    </label>

                    <label htmlFor="invoiceDate">
                        Date
                        <input type="date" id="invoiceDate" onChange={onChange} value={newData.invoiceDate} />
                    </label>

                    <label htmlFor="customerId">Customer</label>
                    <div className={css.group}>
                        <select id="customerId" onChange={onChange} value={newData.customerId}>
                            {filteredCustomers.map((x) => (
                                <option key={x.customerId} value={x.customerId}>
                                    {x.customerName}
                                </option>
                            ))}
                        </select>
                        <input type="text" onChange={filterCustomers} placeholder="Search customers..." />
                    </div>

                    <label htmlFor="contractId">
                        Contract
                        <select id="contractId" onChange={onChange} value={newData.contractId || ''} style={{ width: '100%' }}>
                            <option value="">-- Select Contract --</option>
                            {allContracts
                                .filter((c) => c.customerId === Number(newData.customerId))
                                .map((x) => (
                                    <option key={x.contractId} value={x.contractId}>
                                        {x.contractTitle} / {toShort(x.contractDate)}
                                    </option>
                                ))}
                        </select>
                    </label>

                    <div className={css.group}>
                        <div>
                            <label htmlFor="invoiceTrainingAmount">Training</label>
                            <input type="number" id="invoiceTrainingAmount" onChange={onChange} value={newData.invoiceTrainingAmount} />
                        </div>
                        <div>
                            <label htmlFor="invoiceAccessAmount">Access</label>
                            <input type="number" id="invoiceAccessAmount" onChange={onChange} value={newData.invoiceAccessAmount} />
                        </div>
                        <div>
                            <label htmlFor="invoiceOtherAmount">Other</label>
                            <input type="number" id="invoiceOtherAmount" onChange={onChange} value={newData.invoiceOtherAmount} />
                        </div>
                        <div>
                            <label htmlFor="invoiceTotalAmount">Total</label>
                            <input type="number" id="invoiceTotalAmount" onChange={onChange} value={newData.invoiceTotalAmount} />
                        </div>
                    </div>

                    <label htmlFor="isInvoicePaid">
                        Paid
                        <input type="checkbox" id="isInvoicePaid" onChange={onTogglePaid} checked={newData.isInvoicePaid === 1} />
                    </label>
                </div>

                <div className={css.textArea}>
                    <label htmlFor="invoiceNote">Note</label>
                    <textarea id="invoiceNote" cols="45" rows="30" onChange={onChange} value={newData.invoiceNote} />
                </div>

                <div className={css.buttons}>
                    <button className={func === 'Add' ? css.add : css.edit} onClick={(e) => onAdd(e, newData)}>
                        {func}
                    </button>
                    <button className={css.close} onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </form>
    );
}

export default AddInvoice;
